function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
  fill: "#0099cc",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2485 5111 c-92 -24 -173 -90 -215 -176 l-25 -50 -3 -1274 -2 -1275 -318 316 c-291 290 -322 317 -375 337 -71 26 -164 28 -233 4 -67 -23 -164 -120 -187 -187 -24 -69 -22 -162 4 -233 20 -55 54 -91 633 -669 486 -486 621 -616 661 -635 71 -34 199 -34 270 0 40 19 175 149 661 635 586 586 613 613 634 671 28 78 25 188 -8 255 -28 59 -92 124 -151 152 -68 34 -177 37 -256 7 -56 -20 -82 -43 -377 -337 l-318 -316 -2 1275 -3 1274 -34 63 c-57 105 -144 160 -260 167 -36 2 -79 1 -96 -4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M245 631 c-90 -22 -173 -90 -215 -176 -34 -69 -35 -198 -2 -265 34 -71 75 -113 144 -151 l63 -34 2325 0 2325 0 51 27 c76 40 107 70 145 140 31 58 34 70 34 148 0 78 -3 90 -34 148 -37 69 -79 109 -151 144 l-45 23 -2305 2 c-1268 0 -2318 -2 -2335 -6z"
}));

var SvgDigitalDownload = function SvgDigitalDownload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDigitalDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/digitalDownload.ae123343.svg";
export { ForwardRef as ReactComponent };